import axios from 'axios';
import { history } from './history';

/**
 * @returns Unregister callback
 */
export function axiosInterceptors() {
  axios.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user && user.token) {
      config.headers.common['Authorization'] = `Bearer ${user.token}`
    }

    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.response && 401 === error.response.status) {
      history.push('/login');
    }
    return Promise.reject(error);
  });
}
